import React from "react";
import { Button } from "antd";
import "./style.css";

const CustomBtn = ({ type,size, onClick,icon, children, ...props }) => {
  return (
    <Button size={size || 'medium'} type={type} onClick={onClick} icon={icon} {...props} >
      {children}
    </Button>
  );
};

export default CustomBtn;
